<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-2">
      <div>
        <div class="section-title">{{ $t("seatreservationtype") }}</div>
        <div class="section-subTitle my-2">{{ $t("seatreservationtype") }}</div>
      </div>
      <div class="d-flex align-items-center">
        <div>
          <b-button
            v-if="$can('create', 'Seat Reservation Type')"
            variant="default"
            to="add-seat-reservation-type"
            class="btn-blue"
            >{{ $tc("add") }}</b-button
          >
        </div>

        <div class="d-flex align-items-center">
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => getSeatReserveTypesList(filterIsActive)
            "
          />
        </div>

        <div class="d-none dropdown-curve-container ml-2">
          <b-dropdown
            :disabled="isRoleID"
            :text="selectedStatus"
            variant="dropdown-curve"
            style="width: 200px"
          >
            <b-dropdown-item
              v-for="(dropdownItem, dropdownIndex) in status"
              :key="dropdownIndex"
              href="#"
              @click="onStatusChange(dropdownItem.value)"
              >{{ dropdownItem.value }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="d-none justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="SeatReserveTypes.length > 0"
        v-for="(item, key) in SeatReserveTypes"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.srt_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Seat Reservation Type')"
                  @click="goToRoute('/master/edit-seat-reservation-type', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-seat-reservation-type', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot :status="item.srt_is_active ? 'active' : 'inactive'" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="SeatReserveTypes.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>

          <th class="text-left">
            <img
              v-if="this.columnName != 'srt_name'"
              @click="onSortValue('srt_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('srt_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('srt_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("seatreservationtype", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="SeatReserveTypes.length > 0">
        <tr v-for="(item, key) in SeatReserveTypes" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot :status="item.srt_is_active ? 'active' : 'inactive'" />

              <div class="d-flex align-items-center pl-2">
                <div
                  class="icon-eye blue-icon btn p-0"
                  @click="goToRoute('/master/view-seat-reservation-type', item)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></div>
                <div
                  v-if="$can('update', 'Seat Reservation Type')"
                  class="edit-pen blue-icon mx-2 btn p-0"
                  @click="goToRoute('/master/edit-seat-reservation-type', item)"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></div>
              </div>

              <b-dropdown right variant="edit" class="ml-4" v-if="false">
                <b-dropdown-item
                  v-if="$can('update', 'Seat Reservation Type')"
                  @click="goToRoute('/master/edit-seat-reservation-type', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-seat-reservation-type', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>

          <td>
            <div class="d-flex align-items-center justify-content-start">
              <div class="d-flex text-left" style="width: 25%">
                {{ $tc(item.srt_name, 1) }}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="SeatReserveTypes.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="SeatReserveTypes.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import SeatReserveTypes from "@/helper/formJSONMaster/SeatReserveTypes";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      selectedStatus: "All",
      status: [
        {
          value: "All",
        },
        {
          value: "Active",
        },
        {
          value: "Inactive",
        },
      ],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: SeatReserveTypes.Methods,
      SeatReserveTypes: [],
      SeatReserveTypesCopy: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getSeatReserveTypesList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onStatusChange(value) {
      this.SeatReserveTypes = this.SeatReserveTypesCopy;
      this.selectedStatus = value;
      if (value == "Active") {
        this.SeatReserveTypes = this.SeatReserveTypes.filter(
          (x) => x.srt_is_active
        );
      } else if (value == "Inactive") {
        this.SeatReserveTypes = this.SeatReserveTypes.filter(
          (x) => !x.srt_is_active
        );
      } else {
        this.SeatReserveTypes = this.SeatReserveTypesCopy;
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getSeatReserveTypesList();
      } else {
        this.currentPage = event;
        this.getSeatReserveTypesList();
      }
    },
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { srt_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: srt_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getSeatReserveTypesList();
    },
    getSeatReserveTypesList: function (filterIsActive = "Y") {
      this.SeatReserveTypes = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&filter_is_active=${filterIsActive}`;
      console.log("body :", body);

      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.SeatReserveTypesCopy = data.Records;
            if (data.Records.length > 0) {
              this.SeatReserveTypes = data.Records;

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>
<style>
.pad-right {
  padding-right: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/SeatReservationTypeComponents/seatReservationType.vue